import { Sparkles } from "lucide-react";
import type { InterpretationResponse } from "@/types/interpretation.types";
import { VerdictSection } from "./VerdictSection";
import { KpiSection } from "./KpiSection";
import { DetailSections } from "./DetailSections";
import { NextStepsSection } from "./NextStepsSection";

// Corpo único do painel de interpretação (overlay + página). Fatos determinísticos
// da plataforma; narrativa do modelo (quando houver) com selo "análise do assistente". Estados
// honestos (sem baseline / confiança baixa) já vêm nos fatos.

export function InterpretationBody({ data }: { data: InterpretationResponse }): React.ReactElement {
  const { facts, narrative, narrativeSource } = data;
  return (
    <div className="flex flex-col gap-5 px-5 py-4">
      <VerdictSection verdict={facts.verdict} confidence={facts.confidence} />

      {narrative && narrativeSource === "ASSISTANT" ? (
        <section className="bg-bg-muted-rd/40 rounded-md border border-border-subtle p-3">
          <p className="mb-1.5 inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-brand-600">
            <Sparkles className="h-3 w-3" aria-hidden />
            Análise do assistente
          </p>
          <p className="whitespace-pre-wrap text-[13px] leading-relaxed text-text-secondary">
            {narrative}
          </p>
        </section>
      ) : null}

      <KpiSection kpis={facts.kpis} verdict={facts.verdict} stopCost={facts.stopCost} />
      <DetailSections facts={facts} />
      <NextStepsSection steps={facts.nextSteps} />
    </div>
  );
}
